import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Link, Paper, Radio, RadioGroup,
  Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography,
} from '@mui/material';
import { providersApi } from '../services/api';

/** D27: a NEEDS_REVIEW checkout closes only through one of two provable outcomes. No plain delete. */
export default function CheckoutReview() {
  const [rows, setRows] = useState([]);
  const [active, setActive] = useState(null);
  const [outcome, setOutcome] = useState('NO_SUBSCRIPTION');
  const [externalId, setExternalId] = useState('');
  const [reason, setReason] = useState('');
  const [result, setResult] = useState('');
  const [error, setError] = useState('');

  const load = () => providersApi.getCheckoutsNeedingReview()
    .then((data) => setRows(Array.isArray(data) ? data : []))
    .catch((e) => setError(e.backendMessage || e.message));
  useEffect(() => { load(); }, []);

  const confirm = async () => {
    setError('');
    try {
      const res = await providersApi.resolveCheckout(active.providerId, {
        outcome,
        externalId: outcome === 'SUBSCRIPTION_EXISTS' ? externalId : null,
        reason,
      });
      setResult(`Provider ${active.providerId}: ${res?.outcome || 'resolved'}`);
      setActive(null); setReason(''); setExternalId('');
      load();
    } catch (e) { setError(e.backendMessage || e.message); }
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>Checkouts needing review</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        These reservations are older than PayPal&apos;s idempotency window and cannot be retried automatically.
        Search the PayPal console by the provider&apos;s custom_id and the reservation date before resolving.
      </Typography>
      {result && <Alert severity="success" sx={{ mb: 1 }}>{result}</Alert>}
      {error && <Alert severity="error" sx={{ mb: 1 }}>{error}</Alert>}
      <Table size="small">
        <TableHead>
          <TableRow><TableCell>Provider</TableCell><TableCell>Request id</TableCell><TableCell>PayPal id</TableCell><TableCell>Reserved</TableCell><TableCell /></TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 && (
            <TableRow><TableCell colSpan={5}><Typography variant="body2" color="text.secondary">Nothing to review.</Typography></TableCell></TableRow>
          )}
          {rows.map((r) => (
            <TableRow key={r.providerId}>
              <TableCell>
                <Link component={RouterLink} to={`/providers/${r.providerId}`}>{r.providerTitle || r.providerId}</Link> (custom_id {r.providerId})
              </TableCell>
              <TableCell>{r.requestId}</TableCell>
              <TableCell>{r.externalId || '—'}</TableCell>
              <TableCell>{new Date(r.createdAt).toLocaleString()}</TableCell>
              <TableCell><Button size="small" onClick={() => { setActive(r); setExternalId(r.externalId || ''); }}>Resolve</Button></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Dialog open={!!active} onClose={() => setActive(null)} fullWidth>
        <DialogTitle>Resolve checkout for provider {active?.providerId}</DialogTitle>
        <DialogContent>
          <RadioGroup value={outcome} onChange={(e) => setOutcome(e.target.value)}>
            <FormControlLabel value="NO_SUBSCRIPTION" control={<Radio />} label="I checked PayPal: no subscription exists for this provider" />
            <FormControlLabel value="SUBSCRIPTION_EXISTS" control={<Radio />} label="A subscription exists in PayPal" />
          </RadioGroup>
          {outcome === 'SUBSCRIPTION_EXISTS' && (
            <TextField label="PayPal subscription id" value={externalId} onChange={(e) => setExternalId(e.target.value)} fullWidth sx={{ mt: 1 }} />
          )}
          <TextField label="Reason" value={reason} onChange={(e) => setReason(e.target.value)} fullWidth required sx={{ mt: 2 }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setActive(null)}>Cancel</Button>
          <Button variant="contained" disabled={!reason || (outcome === 'SUBSCRIPTION_EXISTS' && !externalId)} onClick={confirm}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
}
